import { BaseCard } from "./BaseCard.js";
import { CardHeader } from "./internal/CardHeader.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/BareCard.tsx
const BareCard = ({ children, footer, header, Icon, iconColor, fullWidthFooter = false, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(BaseCard, {
		footer,
		fullWidthFooter,
		header: header ? /* @__PURE__ */ jsx(CardHeader, { children: header }) : null,
		Icon,
		iconColor,
		padding: 0,
		radius: 0,
		style: { backgroundColor: "transparent" },
		"data-testid": testId,
		children
	});
};

//#endregion
export { BareCard };